import React, { useEffect, useState } from 'react';
import PieChart from '../../components/PieChart/PieChart';
import { getFullBalance } from '../../services/ExchangeService';
import { getFuturesAccount, getFuturesKeysStatus } from '../../services/FuturesService';
import { getCurrentEnvironment } from '../../utils/CurrentEnvironmentStorage';

/**
 * Alocação do capital em pizzas (visão de portfólio): por ATIVO (spot) e por MERCADO
 * (Spot × Futuros). Caminho frio (tela) — SVG puro, sem dependência nova. Ver item 2
 * do backlog de UI de futuros.
 */
function AllocationCard() {
    const environment = getCurrentEnvironment();
    const [byAsset, setByAsset] = useState(null);     // [{ label, value }] spot por moeda
    const [spotTotal, setSpotTotal] = useState(0);
    const [futNotional, setFutNotional] = useState(0); // notional alavancado dos futuros

    useEffect(() => {
        getFullBalance('USDT')
            .then(info => {
                const rows = Object.entries(info)
                    .filter(([coin, d]) => coin !== 'fiatEstimate' && coin !== 'USDT' && parseFloat(d.fiatEstimate) > 0)
                    .map(([coin, d]) => ({ label: coin, value: parseFloat(d.fiatEstimate) }));
                setByAsset(rows);
                setSpotTotal(rows.reduce((s, r) => s + r.value, 0));
            })
            .catch(() => setByAsset([]));

        // Futuros: só consulta se as chaves do ambiente estão configuradas.
        getFuturesKeysStatus()
            .then(status => {
                const ok = environment === 'test' ? status.testConfigured : status.productionConfigured;
                if (!ok) return;
                return getFuturesAccount(environment).then(acc => {
                    const notional = (acc.positions || []).reduce((s, p) => s + Math.abs(p.amount) * (p.markPrice || p.entryPrice || 0), 0);
                    setFutNotional(notional);
                });
            })
            .catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!byAsset) return null;
    const hasSpot = byAsset.length > 0;
    const hasFutures = futNotional > 0;
    if (!hasSpot && !hasFutures) return null;

    const byMarket = [
        { label: '🪙 Spot', value: spotTotal },
        { label: '⚡ Futuros', value: futNotional },
    ];

    return (
        <div className='card card-body border-0 shadow mb-4'>
            <h6 className='mb-3'>Alocação do Capital</h6>
            <div className='row'>
                {hasSpot && (
                    <div className='col-12 col-lg-6 mb-3'>
                        <small className='text-muted d-block mb-2'>Por ativo (spot)</small>
                        <PieChart data={byAsset} />
                    </div>
                )}
                {hasFutures && (
                    <div className='col-12 col-lg-6 mb-3'>
                        <small className='text-muted d-block mb-2'>Por mercado (valor de mercado spot × notional futuros)</small>
                        <PieChart data={byMarket} />
                    </div>
                )}
            </div>
            <small className='text-muted mt-1'>
                Spot = valor de mercado das posições. Futuros = notional alavancado das posições abertas (exposição, não margem).
            </small>
        </div>
    );
}

export default AllocationCard;
